import enTransl from './en.js'
import ruTransl from './ru.js'

const resources = {
  en: enTransl,
  ru: ruTransl,
}

export default resources